import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initializeApiClient, initializeAuthService, initializeV1TaglessService } from "./services/Services";

const fetchConfig = async (retries = 3) => {
    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            const response = await fetch("/config.json", {
                method: "GET",
                cache: "no-cache",
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch config.json: ${response.status} ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            if (attempt === retries) {
                throw error;
            }
            await new Promise((resolve) => setTimeout(resolve, 100 * attempt));
        }
    }
};

fetchConfig()
    .then((config) => {
        initializeV1TaglessService({
            baseUrl: config.apiHost,
            version: "v1",
        });
        initializeApiClient({
            baseUrl: config.apiHost,
            version: "v1",
        });
        initializeAuthService(config.cognitoUserPoolId, config.cognitoClientId);
        return config;
    })
    .then((config) => {
        const root = ReactDOM.createRoot(document.getElementById("root"));
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <App config={config} />
                </BrowserRouter>
            </React.StrictMode>,
        );
    })
    .catch((error) => {
        console.error("Failed to initialize app:", error);
        document.getElementById("root").innerHTML = `
            <div style="padding: 20px; color: red;">
                <h1>Application Error</h1>
                <p>Failed to load configuration: ${error.message}</p>
            </div>
        `;
    });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
